// extracted by mini-css-extract-plugin
export default {"wrapper":"Loader_wrapper__SZmR3","spinner":"Loader_spinner__B+YTX","spin":"Loader_spin__7yKYz","text":"Loader_text__ciWg+"};